import { render, staticRenderFns } from "./WeChatRegister.vue?vue&type=template&id=14af168c&scoped=true&"
import script from "./WeChatRegister.vue?vue&type=script&lang=js&"
export * from "./WeChatRegister.vue?vue&type=script&lang=js&"
import style0 from "./WeChatRegister.vue?vue&type=style&index=0&id=14af168c&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "14af168c",
  null
  
)

export default component.exports